var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEventBlockGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00033 0.666504C4.40033 0.666504 0.666992 4.39984 0.666992 8.99984C0.666992 13.5998 4.40033 17.3332 9.00033 17.3332C13.6003 17.3332 17.3337 13.5998 17.3337 8.99984C17.3337 4.39984 13.6003 0.666504 9.00033 0.666504ZM2.33366 8.99984C2.33366 5.3165 5.31699 2.33317 9.00033 2.33317C10.542 2.33317 11.9587 2.85817 13.0837 3.7415L3.74199 13.0832C2.85866 11.9582 2.33366 10.5415 2.33366 8.99984ZM9.00033 15.6665C7.45866 15.6665 6.04199 15.1415 4.91699 14.2582L14.2587 4.9165C15.142 6.0415 15.667 7.45817 15.667 8.99984C15.667 12.6832 12.6837 15.6665 9.00033 15.6665Z",
    fill: "#AFAFAF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventBlockGray);
export default __webpack_public_path__ + "static/media/event-block-gray.47214447cdd6c325a48eb66ac06937bb.svg";
export { ForwardRef as ReactComponent };